export default __webpack_public_path__ + "2f2677e4adc4f900a6f1c58b7f054386.png";